module.exports = __webpack_public_path__ + "img/attendees-icon.0eaf75a8.svg";